import styled from 'styled-components'

export default styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  padding-bottom: 15px;
`
